"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _asyncApi = _interopRequireDefault(require("@ux/async-api"));
//
// We want to introduce a small delay to the execution of the bootstrap function
// as we want the current JavaScript execution cycle to end before the bootstrap
// function is executed. The code could be wrapped by a UMD pattern which
// could expose an API that might be required by the functions that execute
// during the boostrapping phase.
//
setTimeout(_asyncApi.default, 0);